/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SystemReportSummaryModule
 */

import { Component, Input } from '@angular/core';

import { PROGRESS_CLASSES } from '../../../constants/system-reports-page.constant';

import './system-report-summary-card-progress-bar.component.less';

/**
 * @description Component for System Report Progress Bar.
 * @author Deepak Chaudhary
 */
@Component({
    selector: 'system-report-summary-card-progress-bar',
    templateUrl: './system-report-summary-card-progress-bar.component.html',
})
export class SystemReportSummaryCardProgressBarComponent {
    @Input()
    public iconColorClass: keyof typeof PROGRESS_CLASSES;

    @Input()
    public value: number;

    @Input()
    public maxValue: number;
}
